import React from 'react';

import {
  fmtPtz, fmtTilePos, fmtTileRC, tilePtz,
} from './helpers';
import SRS from './srs';
import style from './style.module.scss';

const tileFullUrl = (tile) => tile?.url || null;

/** Hit target only — frame is stroked on MosaicCanvas. */
const DetectionBox = ({ box, tile, onOpenDetail }) => {
  const {
    Top, Left, Width, Height,
  } = box.BoundingBox;
  const area = Math.max(0.0001, (Width || 0) * (Height || 0));
  const zIndex = Math.min(99, Math.max(2, Math.round(2 / Math.sqrt(area))));

  return (
    <button
      type="button"
      aria-label={box.label}
      data-crowd-box=""
      className={style.boxHit}
      style={{
        top: `${Top * 100}%`,
        left: `${Left * 100}%`,
        width: `${Width * 100}%`,
        height: `${Height * 100}%`,
        zIndex,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onOpenDetail?.({
          kind: 'detection',
          title: box.label,
          subtitle: `Tile ${fmtTilePos(tile)}`,
          tileUrl: tileFullUrl(tile),
          bbox: box.BoundingBox,
          tile,
          rows: [
            ...(box.details || []),
            ['Tile', fmtTilePos(tile)],
            ...(tile.capturedAt
              ? [['Captured', new Date(tile.capturedAt).toLocaleString()]]
              : []),
          ],
          raw: box.raw || null,
        });
      }}
    />
  );
};

/** Layout cell over mosaic; boxes only when parent marks showBoxes. */
const TileView = ({
  tile, scan, boxes, selectedLabels, showBoxes = true, onOpenDetail, tileKey, boxKeyPrefix,
}) => {
  const ptz = tilePtz(tile, scan);
  const visible = showBoxes
    ? boxes.filter((b) => selectedLabels.has(b.label))
    : [];

  return (
    <div
      className={`${style.tile} ${style.tileOverlay}`}
      data-tile-key={tileKey}
      data-row={tile.row}
      data-col={tile.col}
      data-index={tile.index}
      data-pan={fmtPtz(ptz.pan)}
      data-tilt={fmtPtz(ptz.tilt)}
      data-zoom={fmtPtz(ptz.zoom)}
      title={fmtTileRC(tile.row, tile.col)}
    >
      <SRS.Hits tile={tile} boxKeyPrefix={boxKeyPrefix} />
      {visible.length ? (
        <div className={style.boxes}>
          {visible.map((box) => (
            <DetectionBox
              key={box.id}
              box={box}
              tile={tile}
              onOpenDetail={onOpenDetail}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default TileView;
